import { render, staticRenderFns } from "./addAudience.vue?vue&type=template&id=fb3eb132&scoped=true&lang=pug"
import script from "./addAudience.vue?vue&type=script&lang=js"
export * from "./addAudience.vue?vue&type=script&lang=js"
import style0 from "./addAudience.vue?vue&type=style&index=0&id=fb3eb132&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3eb132",
  null
  
)

export default component.exports